import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./PostForm.css";
import Header from "./Header";
import image_upload_icon from "../assets/image_upload_icon.png";
import gif_upload_icon from "../assets/gif_upload_icon.png";
import file_upload_icon from "../assets/file_upload_icon.png";
import { setCommentRange } from "typescript";
import translations from "./translation";


const PostForm = ({ refresh, loadPosts }) => {
  const [title, setTitle] = useState("");
  const [postText, setPostText] = useState("");
  const [postMessage, setPostMessage] = useState("");
  const [image, setImage] = useState(null);
  const [file, setFile] = useState(null);
  const [gif, setGif] = useState(null);
  const [selectCommunity, setSelectedCommunity] = useState("");
  const [error, setError] = useState("");
  const [fileURL, setfileURL] = useState("");
  const [groupID, setGroupID] = useState(null);
  const currentLanguage = localStorage.getItem("selectedLanguage") || "en";
  const navigate = useNavigate();

  // the handler for submitting a new post. This will call the API to create a new post.
  // while the test harness does not use images, if you had an image URL you would pass it
  // in the attributes field. Posts also does double duty as a message; if you want in-app messaging
  // you would add a recipientUserID for a direct message, or a recipientGroupID for a group chat message.
  // if the post is a comment on another post (or comment) you would pass in a parentID of the thing
  // being commented on. Attributes is an open ended name/value segment that you can use to add
  // whatever custom tuning you need, like category, type, rating, etc.
  useEffect(() => {
    if (!sessionStorage.getItem("token")) {
      // navigate("/login");
    }
  }, []);
  
  const submitHandler = (event) => {
    event.preventDefault();
    if (!selectCommunity) {
      setError(translations[currentLanguage].community_error);
      return; // Exit the function early
    }
    if (title === ""){
      setError(translations[currentLanguage].title_error);
      return; // Exit the function early
    }
    if (postText === ""){
      setError(translations[currentLanguage].post_text_error);
      return; // Exit the function early
    }
    
  

    fetch(process.env.REACT_APP_API_PATH + "/posts", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify({
        authorID: sessionStorage.getItem("user"),
        content: postText,
        "recipientGroupID": groupID,
        attributes: {
          title: title,
          CommunityID: selectCommunity,
          likes: 0,
          fileURL: fileURL,
          hidden: false,
        },
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          // set a status message, and then set a timeout to clear it after a few seconds
          setPostMessage(translations[currentLanguage].post_added);
          setTimeout(() => {
            setPostMessage('');
            window.location.href = `/games/${selectCommunity.toLowerCase()}`;
          }, 5000);
          // clear out the post text box, so you could make a new post
          setPostText("");
          setTitle("");
          setImage(null);
          setFile(null);
          setGif(null);
          setSelectedCommunity("");
        },
        (error) => {
          alert("error!");
        }
      );
  };
  const uploadFile = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    const formData = new FormData();

    formData.append("uploaderID", sessionStorage.getItem("user"));
    formData.append("attributes", JSON.stringify({}));
    formData.append("file", file);

    // make api call to file-uploads endpoint to post the profile picture
    fetch(process.env.REACT_APP_API_PATH + "/file-uploads", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((result) => {
        let file_URL = "https://webdev.cse.buffalo.edu" + result.path;
        setfileURL(file_URL);
      });
  };

  const handleImageUpload = (event) => {
    setImage(event.target.files[0]);
    uploadFile(event);
  };

  const handleFileUpload = (event) => {
    setFile(event.target.files[0]);
    uploadFile(event);
  };

  const handleGifUpload = (event) => {
    setGif(event.target.files[0]);
    uploadFile(event);
  };

  return (
    
    <div className="PostFormPage_wraper">
      <Header/>
      <form onSubmit={submitHandler}>
        <div className="CreatePostForm">
          <div className="PostForm_leftdiv">
            <div className="PostForm_wraper">
              <label>
                <textarea className="PostForm_title"
                  type="text" 
                  value={title}
                  placeholder={translations[currentLanguage].title}
                  onChange={(e) => setTitle(e.target.value)} 
                />
              </label>
              <br />
              <label>
                <textarea className="PostForm_text"
                  rows="10"
                  cols="70"
                  value={postText}
                  placeholder={translations[currentLanguage].post_text}
                  onChange={(e) => setPostText(e.target.value)}
                />
              </label>
              <br />
              <select 
                className="PostForm_dropdown"
                value={selectCommunity}
                onChange={(e) => {
                  setSelectedCommunity(e.target.value);
                  switch (e.target.value) {
                    case "FPS":
                      setGroupID(69);
                      break;
                    case "Battle-Royale":
                      setGroupID(70);
                      break;
                    case "MOBA":
                      setGroupID(73);
                      break;
                    case "Sandbox":
                      setGroupID(71);
                      break;
                    case "Action-Adventure":
                      setGroupID(72);
                      break;
                    default:
                      setGroupID(null);
                      break;
                  }
                }}
              > 
                <option value="" disabled>{translations[currentLanguage].community_error}</option>
                <option value="FPS">{translations[currentLanguage].community1}</option>
                <option value="Battle-Royale">{translations[currentLanguage].community2}</option>
                <option value="MOBA">{translations[currentLanguage].community3}</option>
                <option value="Sandbox">{translations[currentLanguage].community4}</option>
                <option value="Action-Adventure">{translations[currentLanguage].community5}</option>
              </select>

              {error && <div className="PostForm_CommunityError">{error}</div>}
              {postMessage && <div className="PostForm_post_message">{postMessage}</div>}
            </div>
          </div>
          <div className="PostForm_rightdiv">
            <div className="PostForm_rightdiv_img_wrapper">
              {/* Upload Image Button */}
              <label htmlFor="imageUpload"> 
                <img  className="PostForm_rightdiv_image_icon" src={image_upload_icon} alt="Upload Image" />
              </label>
              <input id="imageUpload" type="file" accept="image/*" onChange={handleImageUpload} style={{ display: 'none' }} />

              {/* Upload GIF Button */}
              <label htmlFor="gifUpload">
                <img className="PostForm_rightdiv_gif_icons" src={gif_upload_icon} alt="Upload Image"/>
              </label>
              <input id="gifUpload" type="file" accept="image/gif" onChange={handleGifUpload} style={{ display: 'none' }} />


              {/* Upload File Button */}
              <label htmlFor="fileUpload">
                <img className="PostForm_rightdiv_file_icons" src={file_upload_icon} alt="Upload Image" />
              </label>
              <input id="fileUpload" type="file" accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" onChange={handleFileUpload} style={{ display: 'none' }} />
            </div>

            <div className="PostForm_rightdiv_display">
              {/* Display uploaded files */}
              {image && <img className="uploadedImage" src={URL.createObjectURL(image)} alt="Uploaded Image" />}
              {file && <p className="PostFormPage_file_name">File: {file.name}</p>}
              {gif && <img src={URL.createObjectURL(gif)} alt="Uploaded GIF" />}
              {!image && !file && !gif && <p className="PostForm_upload_placeholder">{translations[currentLanguage].no_file}</p>}
            </div>
            <Link to="/feed" className="PostFormPage_cancel_button_">
              {translations[currentLanguage].cancel}
            </Link>
          </div>
        </div>
        <div className="PostForm_bottom_div">
          <input className="PostFormPage_post_button_" type="submit" value={translations[currentLanguage].post} />

        </div>
      </form>
    </div>
  );
};

export default PostForm;